import React from 'react';
import { Link as ScLink } from '@sitecore-jss/sitecore-jss-react';

var SitecoreLink = function SitecoreLink(props) {
  return /*#__PURE__*/React.createElement(ScLink, props);
};

export { SitecoreLink };